import { useEffect, useState } from 'react';

export function useMediaQuery(query: string) {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/**
 * Tailwind's `lg` breakpoint — the width at which the shell switches from
 * one-pane-at-a-time to side-by-side panes with a persistent sidebar.
 */
export const useIsDesktop = () => useMediaQuery('(min-width: 1024px)');
